import { Grid, Typography } from '@mui/material'
import { FormField } from 'global/components/Form'
import { SelectEmpresa } from 'global/components/Selects'
import TabFuncionariosForm from 'templates/ManutencaoDoPonto/Digitacao/atoms/TabsFuncionarios'

interface Props {
    checked?: number[]
}

export default function FormAssociarFuncionarios({ checked }: Props) {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <SelectEmpresa
                    width="100%"
                    size="medium"
                    helperText=" "
                    hideWhenSingle
                />
            </Grid>
            <TabFuncionariosForm
                formName="funcionarios.funcionarioIds"
                checked={checked}
            />
            <Grid item xs={6}>
                <FormField
                    label="Data inicial"
                    name="funcionarios.dtInicial"
                    type="date"
                    required
                />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    label="Data final"
                    name="funcionarios.dtFinal"
                    type="date"
                    helperText="Deixe em branco para indeterminado"
                />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body2" color="textSecondary">
                    A vinculação de funcionários é opcional. Você pode
                    associá-los agora ou depois, editando esta tabela ou pelo
                    menu de troca de tabela de horário.
                </Typography>
            </Grid>
        </Grid>
    )
}
